module.exports = __webpack_public_path__ + "static/img/Frame 1858.d66cdb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls3/Frame 1858.png
// module id = WRwi
// module chunks = 12